// extracted by mini-css-extract-plugin
module.exports = {"search-button-text":"SearchPlaceholder_search-button-text__r4aGg"};